import { FC, PropsWithChildren } from 'react';

import styles from './wrapper.module.scss';

interface Props extends Required<PropsWithChildren> {
  className?: string;
}

export const TableWrapper: FC<Props> = ({ children, className = '' }) => {
  return <div className={`${styles.wrapper} ${className}`}>{children}</div>;
};
